import { FOLLOW_UP_LISTING, FOLLOW_DETAILS } from "./type";

const initalState = {
  followUpList: {},
  followUpDetails: {},
};

const followUpListReducer = (state = initalState, action) => {
  const { type, payload } = action;
  switch (type) {
    case FOLLOW_UP_LISTING:
      return {
        ...state,
        followUpList: payload,
      };
    case FOLLOW_DETAILS:
      return {
        ...state,
        followUpDetails: payload,
      };
    default:
      return {
        ...state,
      };
  }
};

export default followUpListReducer;
